import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { CostLayerQuantityProgressComponent } from '../cost-layer-quantity-progress/cost-layer-quantity-progress.component';

@Component({
  selector: 'lum-cost-layer-quantity-progress-cell',
  template: `
    <lum-cost-layer-quantity-progress
      [initialQuantity]="initialQuantity"
      [remainingQuantity]="remainingQuantity"
    ></lum-cost-layer-quantity-progress>
  `,
  standalone: true,
  imports: [CommonModule, CostLayerQuantityProgressComponent],
})
export class CostLayerQuantityProgressCellComponent
  implements ICellRendererAngularComp
{
  initialQuantity :number = 0;
  remainingQuantity :number = 0;

  agInit(params :ICellRendererParams) :void {
    this.initialQuantity = Number(params.data?.initialQuantity || 0);
    this.remainingQuantity = Number(params.data?.remainingQuantity || 0);
  }

  refresh(params :ICellRendererParams) :boolean {
    this.agInit(params);

    return true;
  }
}
